import { ApiManager } from '../../core/api-manager';
import { DataManager } from '../../core/data-manager';
import { settings } from '../../config/settings';
import { LanguageProvider } from '../../core/language-provider';
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';



export async function preUpdate(entity, data, id) {

    var d = {...data}

    switch (entity){
        case 'sample': {
            d.sample1 = 'test'
            break;
        }
        case 'ticket': {
        
            return DataManager.getItem('ticket', id).then((response) => {

                const lastMod = response;
                const lastStatus = response?.body[0]?.status?.value;
                console.log('preUpdateTicket', 'lastMod', lastStatus);
                console.log('preUpdateTicket', 'data', data.status);

                if(!lastStatus){
                    return false
                };
                if(!data.status){
                    return false
                };
                if(lastStatus === data.status) {
                    return false
                }
                if(data.status === '5_OPEN'){
                    return false
                }
                return true

            }).then(async (isRequired) => {
                if(isRequired){
                    return await Swal.fire({
                        title: 'Attenzione! Invia notifica all\'utente',
                        text: "Modificando questa segnalazione invierai una notifica all'utente, vuoi procedere?",
                        icon: 'warning',
                        showCancelButton: true,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'Invia Conferma',
                        cancelButtonText: 'Annulla Modifiche'
                    }).then((result) => {
                        if (result.isConfirmed) {
                            return {
                                success: 1,
                                data: d,
                                message: ''
                            }
                        } else {
                            return {
                                success: 0,
                                message: ''
                            }
                        }});
                }else{
                    return {
                        success: 1,
                        data: d,
                        message: ''
                    }
                }
            })
            break;
        }
        default: {
            return {
                success: 1,
                data: d,
                message: ''
            }
        }
    };
    
    


}